import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/components/shadcn/avatar"

import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/shadcn/dropdown-menu"

import { Icon } from '@iconify-icon/solid';
import useLogout from "@/services/auth/useLogout";
import { useApplication } from "@/context/app";

export function UserMenu(props) {

  const { logoutUser } = useLogout();
  const { openPasswordModal } = useApplication();

  return (
    <>
      <DropdownMenuLabel class="p-0 font-normal">
        <div class="flex items-center gap-2 px-1 py-1.5 text-left text-sm pe-3">
          <Avatar class="h-8 w-8 rounded-lg bg-slate-200 dark:bg-slate-800">
            <AvatarImage src={props.user.avatar} alt={props.user.name} />
            <AvatarFallback class="rounded-lg bg-slate-200 dark:bg-slate-800">
              <Icon icon="lucide:circle-user" />
            </AvatarFallback>
          </Avatar>
          <div class="grid flex-1 text-left text-sm leading-tight">
            <span class="truncate font-semibold">{props.user.name}</span>
            <span class="truncate text-xs">{props.user.email}</span>
          </div>
        </div>
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuGroup>
        <DropdownMenuItem onClick={() => openPasswordModal()}>
          <Icon icon="solar:password-linear" />
          Password
        </DropdownMenuItem>
      </DropdownMenuGroup>
      <DropdownMenuSeparator />
      <DropdownMenuItem onClick={() => { logoutUser() }}>
        <Icon icon="lucide:log-out" />
        Log out
      </DropdownMenuItem>
    </>
  );
}
